import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterEvent,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'filter-status',
  templateUrl: './filter-status.component.html',
  styleUrls: ['./filter-status.component.scss'],
})
export class FilterStatusComponent implements OnInit {
  routerSuscription: Subscription;
  constructor(
    public readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly route: ActivatedRoute
  ) {
    this.unitId = route.snapshot.paramMap.get('id');
    this.findUser();

    this.routerSuscription = this.router.events.subscribe(
      async (event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          this.unitId = route.snapshot.paramMap.get('id');
          this.form.reset();
          this.form.value.clear = 0;
          this.form.value.date = undefined;
          this.findUser();
        }
      }
    );
  }
  unitId;
  // @Input() users: any;
  // @Input() unitId: any;
  @Input() caseTypes: any;
  @Input() title: any;
  @Output() newItemEvent = new EventEmitter<string>();
  @Input() fil: any;
  ngOnDestroy(): void {
    this.routerSuscription?.unsubscribe();
  }

  form = this.fb.group({
    date: [false],
    analist: [''],
    caseType: [''],
    clear: [0],
  });
  date: boolean;
  ngOnInit() {
    this.form.patchValue(this.fil);
  }
  users;
  async findUser() {
    await this.userService
      .findUsersByRoleCasetype(this.unitId)
      .subscribe((res: any) => {
        this.users = res;
      });
  }
  filter() {
    this.form.value.clear = 1;
    this.newItemEvent.emit(this.form.value);
  }
  clear() {
    this.form.reset();
    this.form.value.clear = 0;
    this.form.value.date = undefined;
    this.newItemEvent.emit(this.form.value);
  }
}
